import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';
import { SkeletonLine } from '../../ui/Skeleton/SkeletonLine';

// Mirrors the AI summary: the sparkle heading, then two lines of text.
export const HomeGreetingSkeleton: React.FC = () => (
    <div data-testid="home-greeting-skeleton" aria-hidden="true" className="flex flex-col gap-s">
        <div className="flex h-lh items-center gap-s text-body-emphasized">
            <SkeletonBar className="size-4 shrink-0" shape="circle" />
            <SkeletonBar className="h-3.5 w-32" />
        </div>
        <div className="flex flex-col">
            <SkeletonLine lineClassName="text-m" className="w-full" />
            <SkeletonLine lineClassName="text-m" className="w-2/3" />
        </div>
    </div>
);
